import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Action, ActionsSubject } from '@ngrx/store';
import { environment } from '@src/environments';
import { map, Subscription } from 'rxjs';
import { UAParser } from 'ua-parser-js';

export abstract class Logger {
  debug: any;
  info: any;
  warn: any;
  error: any;
}

export interface clientLog {
  message: string;
  eventId?: string;
  error?: string;
  actions?: string[];
  data?: {};
  source?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService implements Logger, OnDestroy {
  subs: Subscription = new Subscription();
  dispatchedActions: string[] = [];
  uaParser: UAParser = new UAParser();

  constructor(
    private httpClient: HttpClient,
    private actionsSubject: ActionsSubject,
  ) {
    this.subs.add(
      this.actionsSubject.pipe(map((action: Action) => action.type)).subscribe((actionType) => {
        this.dispatchedActions.push(actionType);
      }),
    );
  }

  public log(data: Object, publicLog: boolean = false) {
    // Manually inject serverless: true to the data object so we can differentiate btwn client logs
    this.httpClient
      .post(`${publicLog ? 'public-log' : 'secure/client-log'}`, {
        ...data,
        userLocation: environment.isInternal ? 'internal' : 'external',
        serverless: true,
        ...this.getClientContext(),
      })
      .subscribe();
  }

  private getClientContext() {
    const result = this.uaParser.getResult();
    const data = {
      platform: result.os.name,
      platformVersion: result.os.version,
      browser: result.browser.name,
      browserVersion: result.browser.version,
    };
    return data;
  }

  public debug(message: string, code: number) {
    this.log({
      level: 'debug',
      code: code,
      message: message,
    });
  }

  public info(info: clientLog, code: number, publicLog: boolean = false) {
    this.log(
      {
        level: 'info',
        code: code,
        ...info,
      },
      publicLog,
    );
  }

  public warn(warn: clientLog, code: number) {
    this.log({
      level: 'warn',
      code: code,
      ...warn,
    });
  }

  public error(error: clientLog, code: number) {
    this.log({
      level: 'error',
      code: code,
      ...error,
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
